import { Col, Progress, Row, Spin, message, Select } from "components/common";
import { useEffect, useState } from "react";
import { callGetApiWithAuth } from "utils/api";
import { asPercent, asVolume } from "utils/text";
import { Wrapper } from "../RankCard.styled";

export default function PromoterRankCard() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [statData, setStatData] = useState({
    rank: { name: "Unranked" },
    max_rank: { name: "Unranked" },
    next_rank: { name: "Director" },
    acc: 0,
    ap: 0,
    cp: 0,
    mp: 0,
    next_acc: 0,
    next_ap: 0,
    next_cp: 0,
    next_mp: 0,
    acc_percent: 0,
    ap_percent: 0,
    cp_percent: 0,
    mp_percent: 0,
    total_percent: 0,
    is_commission_qualified: false,
  });
  const [viewMode, setViewMode] = useState("current");
  const [nextRanks, setNextRanks] = useState([]);
  const [selectedNextRankIndex, setSelectedNextRankIndex] = useState(0);

  const onGetStatData = (res) => {
    setIsLoaded(true);
    if (!res.success) {
      return message.error(res.message);
    }
    
    // Handle new API response with next_ranks array
    if (res.data.next_ranks && res.data.next_ranks.length > 0) {
      setNextRanks(res.data.next_ranks);
      // Set initial data to first next rank
      const firstNextRank = res.data.next_ranks[0];
      setStatData({
        ...firstNextRank,
        rank: res.data.rank,
        max_rank: res.data.max_rank,
        next_rank: firstNextRank.rank, // The rank we're working towards
      });
      setSelectedNextRankIndex(0);
    } else {
      // Fallback to old API structure if next_ranks not available
      setStatData(res.data);
      setNextRanks([]);
    }
  };
  const onFailStatData = () => {
    setIsLoaded(true);
  };

  const handleNextRankChange = (index) => {
    setSelectedNextRankIndex(index);
    if (nextRanks[index]) {
      const selectedRankData = nextRanks[index];
      setStatData(prevData => ({
        ...selectedRankData,
        rank: prevData.rank,
        max_rank: prevData.max_rank,
        next_rank: selectedRankData.rank,
      }));
    }
  };

  useEffect(() => {
    setIsLoaded(false);
    if (viewMode == "current") {
      callGetApiWithAuth(
        "my_rank/rank_tracker/rank_stats_with_anr",
        onGetStatData,
        onFailStatData
      );
    } else if (viewMode == "last") {
      callGetApiWithAuth(
        "my_rank/rank_tracker/last_rank_stats",
        onGetStatData,
        onFailStatData
      );
    }
  }, [viewMode]);

  return (
    <Wrapper className="white-rounded-bg">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="card-title">Promoter Rank</div>
        <Select
          value={viewMode}
          onChange={(v) => setViewMode(v)}
          options={[
            {
              label: "Current Month",
              value: "current",
            },
            {
              label: "Last Month",
              value: "last",
            },
          ]}
          style={{ width: "160px" }}
        />
      </div>

      {isLoaded ? (
        <Row className="align-items-center" gutter={[24, 24]}>
          <Col xs={24} className="responsive-rank">
            <div className="liquid-container">
              <Progress
                type="circle"
                percent={100 * statData.total_percent}
                strokeWidth={9}
                size="large"
                format={(percent) => {
                  return asPercent(percent / 100);
                }}
                strokeColor={{
                  "0%": "#7FCFF4",
                  "25%": "#0ABAB5",
                  "50%": "#0ABAB5",
                  "75%": "#0ABAB5",
                  "100%": "#7FCFF4",
                }}
              />
            </div>
          </Col>
          <Col xs={24}>
            <Row gutter={[24, 12]}>
              <Col span={12}>
                <div className="rank-box" style={{ display: 'flex', alignItems: 'center', minHeight: '100%' }}>
                  <div style={{ width: '100%' }}>
                    <div className="rank-para">Current Rank</div>
                    <div className="rank-head">{statData.rank.name}</div>
                  </div>
                </div>
              </Col>
              <Col span={12}>
                <div className="rank-box">
                  <div style={{ width: '100%' }}>
                    <div className="rank-para">
                      {nextRanks.length > 1 ? 'Target Rank' : 'Next Rank'}
                    </div>
                    <div className="rank-head">
                      {statData.next_rank?.name || 'Unranked'}
                    </div>
                    {nextRanks.length > 1 && (
                      <div style={{ marginTop: '12px', position: 'relative', height: '32px', width: '100%' }}>
                        <button 
                          onClick={() => handleNextRankChange(Math.max(0, selectedNextRankIndex - 1))}
                          disabled={selectedNextRankIndex === 0}
                          style={{
                            position: 'absolute',
                            left: '0',
                            width: '32px',
                            height: '32px',
                            padding: '0',
                            cursor: selectedNextRankIndex === 0 ? 'not-allowed' : 'pointer',
                            opacity: selectedNextRankIndex === 0 ? 0.5 : 1,
                            border: '1px solid #d9d9d9',
                            borderRadius: '50%',
                            background: '#fff',
                            fontSize: '16px',
                            transition: 'all 0.3s',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          {'<'}
                        </button>
                        <div style={{ 
                          position: 'absolute',
                          left: '50%',
                          top: '50%',
                          transform: 'translate(-50%, -50%)',
                          fontSize: '12px',
                          color: '#666'
                        }}>
                          {selectedNextRankIndex + 1} / {nextRanks.length}
                        </div>
                        <button 
                          onClick={() => handleNextRankChange(Math.min(nextRanks.length - 1, selectedNextRankIndex + 1))}
                          disabled={selectedNextRankIndex === nextRanks.length - 1}
                          style={{
                            position: 'absolute',
                            right: '0',
                            width: '32px',
                            height: '32px',
                            padding: '0',
                            cursor: selectedNextRankIndex === nextRanks.length - 1 ? 'not-allowed' : 'pointer',
                            opacity: selectedNextRankIndex === nextRanks.length - 1 ? 0.5 : 1,
                            border: '1px solid #d9d9d9',
                            borderRadius: '50%',
                            background: '#fff',
                            fontSize: '16px',
                            transition: 'all 0.3s',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          {'>'}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <Row gutter={[24,24]} style={{marginTop: "12px"}}>
            {statData.max_rank && <Col span={24}>
                <div className="rank-box">
                  <div>
                    <div className="rank-para">The Highest Rank You’ve Reached</div>
                    <div className="rank-head">{statData.max_rank.name}</div>
                  </div>
                </div>
              </Col>}
            </Row>
          </Col>

          <Col xs={24}>
            <div>
              <Row gutter={[24, 4]}>
                  {/* <Col span={24}>
                    <div className="line-progress-container">
                      <div className="line-progress-box">
                        <div className="line-progress-title">Marketer Points</div>
                        <div className="line-progress-value">
                          ({asVolume(statData.mp)}/{asVolume(statData.next_mp)})
                        </div>
                      </div>
                      <Progress
                        percent={100 * statData.mp_percent}
                        size="small"
                        strokeWidth={4}
                        strokeColor="#0ABAB5"
                        showInfo={false}
                      />
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="line-progress-container">
                      <div className="line-progress-box">
                        <div className="line-progress-title">Activity Points</div>
                        <div className="line-progress-value">
                          ({asVolume(statData.ap)}/{asVolume(statData.next_ap)})
                        </div>
                      </div>
                      <Progress
                        percent={100 * statData.ap_percent}
                        size="small"
                        strokeWidth={4}
                        strokeColor="#FFAB00"
                        showInfo={false}
                      />
                    </div>
                  </Col> */}
                  <Col span={24}>
                    <div className="line-progress-container">
                      <div className="line-progress-box">
                        <div className="line-progress-title">Customer Points</div>
                        <div className="line-progress-value">
                          ({asVolume(statData.cp)}/{asVolume(statData.next_cp)})
                        </div>
                      </div>
                      <Progress
                        percent={100 * statData.cp_percent}
                        size="small"
                        strokeWidth={4}
                        strokeColor="#FFAB00"
                        showInfo={false}
                      />
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="line-progress-container">
                      <div className="line-progress-box">
                        <div className="line-progress-title">
                          Active Customer Count
                        </div>
                        <div className="line-progress-value">
                          ({asVolume(statData.acc)}/{asVolume(statData.next_acc)})
                        </div>
                      </div>
                      <Progress
                        percent={100 * statData.acc_percent}
                        size="small"
                        strokeWidth={4}
                        strokeColor="#FFAB00"
                        showInfo={false}
                      />
                    </div>
                  </Col>
                  <Col span={24}>
                    <div className="line-progress-container">
                      <div className="line-progress-box">
                        <div className="line-progress-title">
                          Commission Qualified
                        </div>
                        <div className="line-progress-value">
                          {statData.is_commission_qualified ? (
                            <>
                              <span style={{ color: "green" }}>✅</span> Yes
                            </>
                          ) : (
                            <>
                              <span style={{ color: "red" }}>❌</span>No
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
            </div>
          </Col>
        </Row>
      ) : (
        <div style={{ height: 300 }}>
          <Spin spinning={true} className="loading-icon" />
        </div>
      )}
    </Wrapper>
  );
}
